import React, { useEffect, useState, useRef } from 'react';

function PdfViewerModal() {
  console.log('PdfViewerModal componente inicializado');
  
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfTitle, setPdfTitle] = useState('Relatório');
  const [scale, setScale] = useState(100);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const pdfBlobRef = useRef(null); // Guardar referência do blob para evitar garbage collection

  // Função para detectar se é Android
  const isAndroid = () => {
    return /android|webos|iphone|ipad|ipot|blackberry|iemobile|opera mini/i.test(
      navigator.userAgent.toLowerCase()
    );
  };

  // Função para imprimir diretamente
  const printDirectly = (url) => {
    const printWindow = window.open(url, '_blank');
    if (printWindow) {
      printWindow.onload = () => {
        printWindow.print();
        // Fecha a aba após 1 segundo da abertura da impressão
        setTimeout(() => {
          printWindow.close();
        }, 1000);
      };
    }
  };

  // Função para carregar dados do PDF
  const loadPdfData = () => {
    const pdfData = sessionStorage.getItem('pdfViewerData');
    console.log('Tentando carregar PDF do sessionStorage...', { exists: !!pdfData });
    
    if (pdfData) {
      try {
        const parsedData = JSON.parse(pdfData);
        console.log('Dados do PDF parseados com sucesso:', { 
          title: parsedData.title,
          pdfId: parsedData.pdfId,
          hasUrl: !!parsedData.url
        });
        
        const { url, title, pdfId } = parsedData;
        
        // Verificar se o blob ainda existe em pdfStorage
        if (pdfId && window.pdfStorage && window.pdfStorage[pdfId]) {
          console.log('Blob encontrado em pdfStorage');
        }
        
        console.log('Definindo pdfUrl:', url?.substring(0, 50));
        setPdfUrl(url);
        setPdfTitle(title || 'Relatório');
        
        const isMobileDevice = isAndroid();
        setIsMobile(isMobileDevice);

        // Se for Android, vai direto para impressão
        if (isMobileDevice) {
          setTimeout(() => {
            printDirectly(url);
          }, 100);
        }
      } catch (error) {
        console.error('Erro ao recuperar dados do PDF:', error);
      }
    } else {
      console.log('Nenhum dado de PDF encontrado no sessionStorage');
    }
  };

  // Recuperar dados do sessionStorage quando o componente montar e monitorar mudanças
  useEffect(() => {
    console.log('PdfViewerModal montado, registrando listeners');
    
    let hasLoaded = false;

    const handleLoad = () => {
      if (!hasLoaded) {
        console.log('Iniciando carregamento do PDF na montagem...');
        hasLoaded = true;
        loadPdfData();
      }
    };

    // Tentar carregar dados ao montar
    handleLoad();

    // Listener para evento customizado disparado pelo utils/relatoriosGlobais
    const handlePdfUpdate = (event) => {
      console.log('Evento pdfViewerUpdate recebido no PdfViewerModal', event);
      console.log('Event detail:', event.detail);
      hasLoaded = false;
      loadPdfData();
    };

    window.addEventListener('pdfViewerUpdate', handlePdfUpdate, true); // capture phase
    
    // Também tentar carregar a cada 200ms durante 5 segundos (fallback robusto)
    const fallbackInterval = setInterval(() => {
      console.log('Fallback: tentando carregar PDF...');
      loadPdfData();
    }, 200);
    
    const timeoutHandle = setTimeout(() => {
      console.log('Parando fallback após 5 segundos');
      clearInterval(fallbackInterval);
    }, 5000);

    return () => {
      console.log('PdfViewerModal sendo desmontado, removendo listeners');
      window.removeEventListener('pdfViewerUpdate', handlePdfUpdate, true);
      clearInterval(fallbackInterval);
      clearTimeout(timeoutHandle);
    };
  }, []);

  const handleDownload = () => {
    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${pdfTitle || 'relatorio'}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handlePrint = () => {
    if (pdfUrl) {
      const printWindow = window.open(pdfUrl);
      if (printWindow) {
        printWindow.print();
      }
    }
  };

  const handleClose = () => {
    // Limpar URL do blob
    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl);
    }
    // Limpar referência do blob
    pdfBlobRef.current = null;
    
    sessionStorage.removeItem('pdfViewerData');
    setPdfUrl(null);
    setPdfTitle('Relatório');
  };

  if (!pdfUrl) {
    console.log('PDF URL é null, modal não será renderizado');
    return null;
  }

  // Em Android, o modal não é renderizado (já vai direto para impressão)
  if (isMobile) {
    console.log('Em dispositivo mobile, não renderizando modal');
    return null;
  }
  
  console.log('Renderizando PdfViewerModal com URL:', pdfUrl.substring(0, 50));

  // Comportamento normal para Desktop (iframe)
  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', position: 'fixed', zIndex: 1055 }}
    >
      <div className="modal-dialog modal-lg" style={{ maxWidth: '85vw', height: '85vh' }}>
        <div className="modal-content h-100">
          {/* Header */}
          <div className="modal-header bg-primary text-white py-2">
            <div className="d-flex align-items-center flex-grow-1">
              <i className="bi bi-file-earmark-pdf me-2"></i>
              <h6 className="m-0 flex-grow-1">
                {pdfTitle || 'Visualizador de Relatório'}
              </h6>
            </div>

            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handleClose}
              title="Fechar"
            ></button>
          </div>

          {/* Body com PDF */}
          <div className="modal-body p-0 pdf-viewer-container" style={{ flex: 1, overflow: 'hidden' }}>
            <iframe
              key={pdfUrl}
              src={pdfUrl}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              title="PDF Viewer"
              onLoad={() => console.log('iframe carregado com sucesso')}
              onError={() => console.error('Erro ao carregar iframe')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PdfViewerModal;
